export default __webpack_public_path__ + "static/media/Untitled-2-02.a675327a.png";